import cn from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { cls } from '@mssgme/helpers';
import styles from './ContentOverlay.scss';

export const ContentOverlay = ({ children, overlay, striped, dashed, ...rest }) => {
    return (
        <div className={cn(styles.root, striped && styles.striped, dashed && styles.dashed)}>
            <div {...cls(styles.blockedContent, rest)}>
                {children && <div className={styles.wrappedContent}>{children}</div>}
            </div>

            <div className={styles.blockedOverlay}>
                <div className={styles.blockedWrapper}>{overlay}</div>
            </div>
        </div>
    );
};

ContentOverlay.propTypes = {
    children: PropTypes.any,
    overlay: PropTypes.any,
    striped: PropTypes.bool,
    dashed: PropTypes.bool,
};
